import React from 'react'

// Input component with label and error display

const Input = ({ label, error, ...props }) => {
    return (
        <div className="mb-4">
            {label && <label className="block text-sm font-medium mb-2">{label}</label>}
            <input
                className={`w-full px-4 py-2 rounded-lg border dark:bg-gray-700 dark:border-gray-600 dark:text-white transition ${
                    error ? 'border-red-500' : 'border-gray-300 focus:border-blue-500'
                } focus:outline-none focus:ring-1 focus:ring-blue-500`}
                {...props}
            />
            {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
        </div>
    );
};

export default Input
